import { CheckCircle } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import { GenAlertDialog } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';

export default function DiscardedOrderConfirmation({ open, onClose }) {
  const { t } = useTranslation(['orders', 'global']);

  return (
    <GenAlertDialog
      open={open}
      onClose={onClose}
      title={t('newOrder.discardedTitle')}
      titleIconColor={'success'}
      closeText={t('wOrderServicesDeletePopUp.alertButton')}
      titleIcon={CheckCircle}
    >
      <Grid
        container
        direction={'row'}
        alignItems="center"
        justifyContent={'center'}
      >
        <Grid item>
          <Typography variant="Body1">
            {t('newOrder.discardedMessage')}
          </Typography>
        </Grid>
      </Grid>
    </GenAlertDialog>
  );
}
